export const gdmModesOfInheritance = [
  {
    value: 'Autosomal dominant inheritance (HP:0000006)',
    label: 'Autosomal dominant inheritance (HP:0000006)',
    adjectives: [
      'with maternal imprinting (HP:0012275)',
      'with paternal imprinting (HP:0012274)',
      'sex-limited (HP:0001470)',
      'with genetic anticipation',
      'primarily or exclusively de novo',
      'mosaic'
    ]
  },
  {
    value: 'Autosomal recessive inheritance (HP:0000007)',
    label: 'Autosomal recessive inheritance (HP:0000007)',
    adjectives: [
      'with genetic anticipation',
      'sex-limited'
    ]
  },
  {
    value: 'Mitochondrial inheritance (HP:0001427)',
    label: 'Mitochondrial inheritance (HP:0001427)',
    adjectives: [
      'primarily or exclusively homoplasmic',
      'primarily or exclusively heteroplasmic'
    ]
  },
  {
    value: 'Semidominant inheritance (HP:0032113)',
    label: 'Semidominant inheritance (HP:0032113)',
    adjectives: []
  },
  {
    value: 'X-linked inheritance (HP:0001417)',
    label: 'X-linked inheritance (HP:0001417)',
    adjectives: [
      'dominant (HP:0001423)',
      'recessive (HP:0001419)',
      'primarily recessive with milder female expression'
    ]
  },
  {
    value: 'Other',
    label: 'Other',
    adjectives: [
      'Y-linked inheritance (HP:0001450)',
      'Somatic mutation (HP:0001428)',
      'Multifactorial inheritance (HP:0001426)',
      'Codominant inheritance',
      'Mosaic'
    ]
  },
  {
    value: 'Undetermined mode of inheritance (HP:0000005)',
    label: 'Undetermined mode of inheritance (HP:0000005)',
    adjectives: []
  },
  {
    value: 'Typified by somatic mosaicism (HP:0001442)',
    label: 'Typified by somatic mosaicism (HP:0001442)',
    adjectives: []
  }
];
